import React, { useCallback, useState } from 'react';
import { MailOutlined } from '@ant-design/icons';
import { Button, Form, Input, message } from 'antd';
import { forgotPassword } from 'api/login';
import { Link } from 'react-router-dom';

export const ForgotPasswordForm = props => {
  const [loading, setLoading] = useState(false);

  const onSignUp = useCallback(values => {
    setLoading(true);
    return new Promise(async resolve => {
      try {
        const response = await forgotPassword(values);

        if (response.status === 200) {
          resolve({});
          message.success('Se ha enviado un correo de seguimiento a tu cuenta de correo.');
        } else {
          message.error('Algo ocurrió mal. Por favor verifica tus credenciales.');
          resolve({ req: 404 });
        }
        setLoading(false);
      } catch (_) {
        message.error('Algo ocurrió mal. Por favor verifica tus credenciales.');
        setLoading(false);
        resolve({ req: 'error' });
      }
    });
  }, []);

  return (
    <>
      <Form layout="vertical" name="register-form" onFinish={onSignUp}>
        <Form.Item
          className="show-error-help"
          name="email"
          label="Correo electrónico"
          rules={[
            {
              required: true,
              message: 'Requerido',
            },
            {
              type: 'email',
              message: 'Verifica que el correo sea válido',
            },
          ]}
        >
          <Input prefix={<MailOutlined className="text-primary" />} />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" block loading={loading}>
            Restablecer contraseña
          </Button>
        </Form.Item>
        <div className="flex flex-col items-center">
          <span className="text-gray-600 font-bold">¿Tienes una cuenta?</span>
          <Link to="/" className="font-size-s font-weight-normal text-muted">
            Inicia sesión
          </Link>
        </div>
      </Form>
    </>
  );
};

export default ForgotPasswordForm;
